import PropTypes from 'prop-types'
import React from 'react'
import { nodeTypes } from '../../Canvas/nodes'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydSelect from '../../../../commonDesign/SydSelect'

export const NodeProps = ({ node, onUpdateNode }) => {
  const nodeTypeSelectOptions = Object.entries(nodeTypes).map(([key, { label }]) => ({
    label: label,
    value: key
  }))
  const sizeOptions = [
    { label: 'Small', value: 'sm' },
    { label: 'Medium', value: 'md' },
    { label: 'Large', value: 'lg' }
  ]

  return (
    <>
      <p className='m-0 font-size-sm'>Node Options</p>

      <div className='flex gap-2 w-full'>
        <SydLabel label='Node Style' style={{ flex: 1 }}>
          <SydSelect
            size='sm'
            type='type'
            onChange={(e) => onUpdateNode(['type'], e.target.value)}
            value={node.type ?? 'default'}
            className='mb-2'
            options={nodeTypeSelectOptions}
            minWidth='0'
          />
        </SydLabel>
        <SydLabel label='Node Size'>
          <SydSelect
            size='sm'
            type='type'
            onChange={(e) => onUpdateNode(['data', 'nodeProps', 'size'], e.target.value)}
            value={node.data?.nodeProps?.size ?? 'md'}
            className='mb-2'
            options={sizeOptions}
            minWidth='100px'
          />
        </SydLabel>
      </div>
    </>
  )
}
NodeProps.propTypes = {
  node: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.shape({
      nodeProps: PropTypes.shape({
        size: PropTypes.string
      })
    })
  }).isRequired,
  onUpdateNode: PropTypes.func.isRequired
}
